<template lang="html">
  <div class="content content--inner">
    <div class="actions">
      <div v-if="!isBatchModeOn"
           class="ai-button ai-button--clear actions__button"
           @click="enableBatchMode">
        批量管理
      </div>
      <div v-else>
        <div v-if="items.some(i => !i.selected)"
             class="ai-button ai-button--clear actions__button actions__button--small"
             @click="setAllItemsSelectState(true)">
          全选
        </div>
        <div v-else
             class="ai-button ai-button--clear actions__button"
             @click="setAllItemsSelectState(false)">
          取消全选
        </div>
        <div class="ai-button
                    ai-button--clear
                    actions__button
                    actions__button--danger
                    actions__button--small"
             @click="showDeleteMultipleConfirm">
          删除
        </div>
        <div class="ai-button ai-button--clear actions__button actions__button--small"
             @click="disableBatchMode">
          完成
        </div>
      </div>
      <div class="ai-button ai-button--primary actions__button" @click="onClickCreateItemButton">
        <i class="material-icons">add</i>
        添加商品
      </div>
      <AiInputGroup placeholder="请输入搜索内容" class="actions__search">
        <i class="material-icons actions__icon">search</i>
      </AiInputGroup>
    </div>
    <div ref="itemList" class="item-list">
      <div v-for="item in items" :key="item.id" class="item-list__item">
        <div class="item-list__thumb">
          <SelectableItem :style="itemStyle"
                          :mode="isBatchModeOn ? 'select' : 'default'"
                          :selected.sync="item.selected"
                          :src="item.photos_list | firstImage"
                          :selectable="isBatchModeOn"
                          :mark-size="20" />
          <div v-if="!isBatchModeOn" class="item-list__thumb-actions">
            <div class="item-list__thumb-button item-list__thumb-button--blue"
                 @click="openEditDialog(item)">
              编辑
            </div>
            <div class="item-list__thumb-button item-list__thumb-button--orange"
                 @click="showDeleteConfirm(item)">
              删除
            </div>
          </div>
        </div>
        <div class="item-list__item-title" :style="titleStyle">
          {{ item.name }}
        </div>
      </div>
    </div>
    <AiPagination v-model="currentPage"
                  class="pagination"
                  :total-page-count="totalPageCount" />
    <AiDialog class="item-dialog"
              width="800"
              :visible.sync="itemDialogVisible"
              @close="closeDialog">
      <div slot="header" class="item-dialog__header">
        {{ mode === 'edit' ? '编辑商品' : '添加商品' }}
      </div>
      <div class="item-dialog__content">
        <form class="form">
          <div class="form-item">
            <label class="form-item__label">
              商品图片
            </label>
            <div class="form-item__content thumb">
              <!-- TODO -->
              <div class="thumb__hint">
                (首张照片为主图)
              </div>
              <div class="thumb__thumbs">
                <div v-for="(image, index) in thumbList"
                     :key="index"
                     class="thumb__image-wrapper"
                     :draggable="false">
                  <img :src="image" class="thumb__image" :draggable="false">
                  <div class="thumb__image-remove" @click="removeThumb(image)">
                    -
                  </div>
                </div>
                <AiImageUpload v-if="thumbList.length < 5"
                               ref="uploader"
                               text="上传照片"
                               accept="image/*"
                               width="60"
                               height="60"
                               size="small"
                               class="thumb__upload"
                               @change="onThumbLoaded"
                               @filesize="onLogoImageSize"
                               :draggable="false" />
              </div>
            </div>
          </div>
          <div class="form-item">
            <label class="form-item__label">
              商品名称
            </label>
            <div class="form-item__content">
              <el-input v-model="currentItem.name"
                        type="text"
                        maxlength="20"
                        placeholder="请输入不超过20字" />
            </div>
          </div>
          <div class="form-item">
            <label class="form-item__label">
              商品描述
            </label>
            <div class="form-item__content">
              <el-input v-model="currentItem.description"
                        type="textarea"
                        maxlength="50"
                        placeholder="请输入不超过5行, 可在右侧预览效果" />
            </div>
          </div>
        </form>
        <div class="preview">
          <div class="item-info">
            <div class="item-info__title">
              {{ currentItem.name }}
            </div>
            <div class="item-info__text">
              <div v-for="(line, index) in wrappedDescription" :key="index">
                {{ line }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="item-dialog__footer">
        <div class="ai-button ai-button--primary"
             @click="updateItem">
          确 定
        </div>
        <div class="ai-button" @click="closeDialog">
          取 消
        </div>
      </div>
    </AiDialog>
  </div>
</template>

<script>
import SelectableItem from '@/components/editor/selectable-item.vue';

const createSuccess = require('@/assets/views/users/create_success.svg');
const deleteSuccess = require('@/assets/views/users/delete_success.svg');

export default {
  components: {
    SelectableItem
  },
  filters: {
    firstImage(imageList) {
      if (!imageList || !imageList.length) return '';
      return imageList[0];
    }
  },
  data: () => ({
    items: [],
    currentItem: {
      photos_list: [],
      imagesAdding: [],
      imagesDeleting: []
    },
    thumbList: [],
    itemStyle: {},
    titleStyle: {},
    currentPage: 1,
    totalPageCount: 10,
    itemDialogVisible: false,
    mode: 'edit',
    isBatchModeOn: false
  }),
  computed: {
    wrappedDescription() {
      return this.currentItem.description ? this.currentItem.description.split('\n') : [];
    }
  },
  watch: {
    currentItem() { this.updateThumbs(); }
  },
  mounted() {
    window.addEventListener('resize', this.calcStyles);
    this.calcStyles();

    this.getItems();
  },
  beforeDestroy() {
    // do something before destroying vue instance
    window.removeEventListener('resize', this.calcStyles);
  },
  methods: {
    calcStyles() {
      const { itemList: { clientWidth } } = this.$refs;
      const targetWidth = (clientWidth - 250) / 6;
      this.itemStyle = {
        height: `${targetWidth}px`,
        width: `${targetWidth}px`
      };
      this.titleStyle = {
        width: `${targetWidth}px`
      };
    },
    onClickCreateItemButton() {
      this.mode = 'create';
      this.currentItem = {
        name: '',
        description: '',
        imagesAdding: [],
        imagesDeleting: [],
        photos_list: []
      };
      this.itemDialogVisible = true;
    },
    openEditDialog(item) {
      this.mode = 'edit';
      this.currentItem = item;
      this.currentItem.imagesAdding = [];
      this.currentItem.imagesDeleting = [];
      this.itemDialogVisible = true;
    },
    closeDialog() {
      this.currentItem = {
        photos_list: [],
        imagesAdding: [],
        imagesDeleting: []
      };
      this.itemDialogVisible = false;
    },
    onThumbLoaded(src) {
      if (!src || !src.length) return;
      this.$log('thumb loaded');
      this.currentItem.imagesAdding = [...this.currentItem.imagesAdding, src];
      this.updateThumbs();
      this.$refs.uploader.clear();
    },
    onLogoImageSize(size) {
      this.logosize = size/Math.pow(1024,2);
      if(this.logosize > 2)
      {
       this.$message('图片尺寸大于2M,请重新选择');
      }
    //  console.log('this.logosize:',this.logosize);
    },
    updateItem() {
      if(this.logosize > 2)
      {
        this.$message('图片尺寸大于2M,请重新选择');
        return;
      }
      if (this.mode === 'edit') this.editItem();
      if (this.mode === 'create') this.addItem();
    },
    removeThumb(image) {
      const item = this.currentItem;
      if (item.photos_list.includes(image)) {
        item.imagesDeleting.push(image);
      } else {
        item.imagesAdding = item.imagesAdding.filter(i => i !== image);
      }
      this.updateThumbs();
    },
    updateThumbs() {
      if (!this.currentItem || !this.currentItem.photos_list) this.thumbList = [];
      this.thumbList = [
        ...this.currentItem.photos_list.filter(
          i => !this.currentItem.imagesDeleting.includes(i)
        ),
        ...this.currentItem.imagesAdding
      ];
    },
    setAllItemsSelectState(selected) {
      this.items.forEach((i) => { i.selected = selected; });
    },
    showDeleteConfirm(item) {
      this.$confirm({
        title: '警 告',
        message: '确认要删除该商品吗?'
      }).then(() => {
        this.deleteItem(item.id);
      }).catch(() => {});
    },
    showDeleteMultipleConfirm() {
      this.$confirm({
        title: '警 告',
        message: '确认要删除这些商品吗?'
      }).then(() => {
        this.deleteItems();
      }).catch(() => {});
    },
    enableBatchMode() {
      this.items.forEach((i) => { i.selected = false; });
      this.isBatchModeOn = true;
    },
    disableBatchMode() {
      this.isBatchModeOn = false;
    },
    async getItems(pageIndex) {
      try {
        const {
          data: { data: { data } },
          page_count: pageCount,
          page_nb: currentPage
        } = await this.$http.post(
          '/admin/list-products?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
          {
            store_id: this.$route.params.modelId,
            page_nb: pageIndex
          }
        );
        this.items = data.map((i) => {
          const result = { selected: false };
          Object.assign(result, i);
          return result;
        });
        this.totalPageCount = pageCount;
        this.currentPage = currentPage;
      } catch (error) {
        this.$log(error.error_msg || error);
      }
    },
    async editItem() {
      const {
        id, name, description, imagesAdding, imagesDeleting, photos_list: photoList
      } = this.currentItem;
      this.$log(id, name, description, imagesAdding, imagesDeleting, photoList);
      try {
        const { data } = await this.$http.post(
          '/admin/modify-product?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
          {
            store_id: this.$route.params.modelId,
            product_id: id,
            name,
            description,
            new_photos: imagesAdding.map(i => i.replace(/data:image.*?,/gi, '')),
            delete_photo_ids: imagesDeleting.map(i => photoList.indexOf(i))
          }
        );
        if (data.error_no === 200) {
          this.$message('修改成功');
          this.closeDialog();
          this.getItems(this.currentPage);
        } else {
          this.$log(data.error_msg);
        }
      } catch (error) {
        this.$log(error.error_msg || error);
      }
    },
    async addItem() {
      const { name, description, imagesAdding } = this.currentItem;
      try {
        const { data } = await this.$http.post(
          '/admin/add-product?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
          {
            store_id: this.$route.params.modelId,
            name,
            description,
            new_photos: imagesAdding.map(i => i.replace(/data:image.*?,/gi, ''))
          }
        );
        if (data.error_no === 200) {
          this.$message.basic({
            message: '添加成功',
            icon: createSuccess
          });
          this.closeDialog();
          this.getItems(this.currentPage);
        } else {
          this.$log(data.error_msg);
        }
      } catch (error) {
        this.$log(error.error_msg || error);
      }
    },
    async deleteItem(itemId) {
      try {
        const { data } = await this.$http.post(
          '/admin/delete-products?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
          {
            store_id: this.$route.params.modelId,
            product_ids: [itemId]
          }
        );
        if (data.error_no === 200) {
          this.$message.basic({
            message: '删除成功',
            icon: deleteSuccess
          });
          this.getItems(this.currentPage);
        } else {
          this.$log(data.error_msg);
        }
      } catch (error) {
        this.$log(error.error_msg || error);
      }
    },
    async deleteItems() {
      try {
        const { data } = await this.$http.post(
          '/admin/delete-products?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
          {
            store_id: this.$route.params.modelId,
            product_ids: this.items.filter(i => i.selected).map(i => i.id)
          }
        );
        if (data.error_no === 200) {
          this.$message('删除成功');
          this.getItems(this.currentPage);
          this.disableBatchMode();
        } else {
          this.$log(data.error_msg);
        }
      } catch (error) {
        this.$log(error.error_msg || error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.actions {
  display: flex;
  justify-content: flex-end;
  padding: 30px 0 20px;
  margin: 0 80px;
  border-bottom: 1px solid #e5e5e5;

  &__search {
    margin-left: 15px;
  }

  &__icon {
    margin: 0;
    font-size: 14px;
    color: #9e9e9e;
  }

  &__button {
    width: 84px;
    height: 22px;
    font-size: 11px;
    margin: 0 5px;

    .material-icons {
      margin-right: 0;
      font-size: 14px;
    }

    &--small {
      width: 46px;
    }

    &--danger {
      color: #f50;
      border-color: #f50;
    }
  }
}

.item-list {
  margin: 30px 80px;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-column-gap: 50px;
  grid-row-gap: 25px;
  position: relative;

  &__item {
    position: relative;
  }

  &__item-title {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    color: #000;
    font-size: 14px;
    text-align: center;
    margin-top: 5px;
  }

  &__thumb {
    position: relative;

    &:hover .item-list__thumb-actions {
      opacity: 1;
    }
  }

  &__thumb-actions {
    position: absolute;
    bottom: 2px;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-items: stretch;
    align-items: stretch;
    opacity: 0;
    transition: .15s;
  }

  &__thumb-button {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, .5);
    color: #fff;
    font-size: 14px;
    height: 30px;
    user-select: none;
    cursor: pointer;

    &--blue:hover,
    &--blue:active {
      background-color: #108ee9;
    }

    &--orange:hover,
    &--orange:active {
      background-color: #f50;
    }
  }
}

.pagination {
  width: 100%;
  margin: 30px 0;
}

.item-dialog {
  &__header {
    height: 50px;
    display: flex;
    align-items: center;
    margin-left: 20px;
    font-weight: 500;
    color: #6c6c6c;
  }

  &__content {
    display: flex;
    padding: 20px 16px;
  }

  &__footer {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    flex-direction: row-reverse;

    .ai-button {
      width: 59px;
      height: 26px;
      margin: 0 10px;
      font-size: 14px;
    }
  }
}

.form {
  display: inline-block;
}

.form-item {
  margin-bottom: 20px;
  width: 100%;
  display: flex;

  &:last-child {
    margin-bottom: 0;
  }

  &__label {
    display: inline-flex;
    width: 70px;
    color: #6c6c6c;
    font-size: 14px;
    height: 28px;
    align-items: center;
    flex-direction: row-reverse;
    user-select: none;
  }

  &__content {
    display: inline-block;
    margin-left: 12px;

    .ai-input-wrapper {
      width: 368px;
      height: 28px;
    }
  }
}

.thumb {
  &__hint {
    font-size: 12px;
    line-height: 28px;
    height: 28px;
    color: #ccc;
  }

  &__upload {
    display: inline-block;
  }

  &__thumbs {
    display: flex;
    align-items: center;
  }

  &__image-wrapper {
    position: relative;
  }

  &__image {
    display: inline-block;
    margin-right: 10px;
    position: relative;
    width: 60px;
    height: 60px;
    padding: 2px;
    border: 1px solid #d9d9d9;
    object-fit: contain;
  }

  &__image-remove {
    position: absolute;
    right: 7px;
    top: -7px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background-color: #f50;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    cursor: pointer;
    user-select: none;
  }
}

.preview {
  flex: 1;
  display: flex;
  justify-content: center;
  margin: 0 10px;
  padding: 20px 0;
  border: 1px solid #979797;
  background-color: #d8d8d8;
}

.item-info {
  min-width: 272px;
  min-height: 288px;
  text-align: right;
  color: #fff;
  filter: drop-shadow(0 2px 2px #000);
  user-select: none;
  pointer-events: none;

  &__title {
    font-size: 26px;
    line-height: 40px;
    border-bottom: 2px solid #fff;
  }

  &__text {
    font-size: 14px;
    line-height: 20px;
    margin-top: 8px;
  }
}
</style>
